import { render, staticRenderFns } from "./Archivos.vue?vue&type=template&id=725a911f&scoped=true&"
import script from "./Archivos.vue?vue&type=script&lang=js&"
export * from "./Archivos.vue?vue&type=script&lang=js&"
import style0 from "./Archivos.vue?vue&type=style&index=0&id=725a911f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725a911f",
  null
  
)

export default component.exports